<template>
  <div id="contenedor-eliminar-catalogo-auditoria-etiqueta">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar auditoria etiqueta </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar la etiqueta" {{ etiquetaEliminar.auditoriaEtiqueta.descripcion }}" del
          detalle?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="No" class="mr-3"> </custom-button>
        <custom-button
          @click="mixEliminarEtiqueta"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Si"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixAuditoriasEtiquetas from './mixAuditoriasEtiquetas';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AuditoriasEtiquetasEliminar',
  mixins: [mixAuditoriasEtiquetas],
  props: {
    etiquetasAgregadas: {
      type: Array,
      required: true,
    },
    etiquetaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style></style>
